"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importLocale = exports.doImport = void 0;
var getLocalization;
function isL10nModule(item) {
  return typeof item.current === 'string' && item.globalize instanceof Function;
}
function doImport(locale, fallback) {
  var _a;
  try {
    if (!getLocalization) {
      var root = global || window;
      getLocalization = (_a = root === null || root === void 0 ? void 0 : root.Bernie) === null || _a === void 0 ? void 0 : _a.localization;
      if (!(getLocalization instanceof Function)) {
        throw new Error('Expected "Bernie.localization" to return a function of type "(locale: string) => L10nModule"');
      }
    }
    var l10nMod = getLocalization(locale);
    if (!isL10nModule(l10nMod)) {
      throw new Error('Expected "Bernie.localization" to return an object of type "L10nModule".');
    }
    return l10nMod;
  } catch (error) {
    if (fallback && fallback !== locale) {
      return doImport(fallback);
    } else {
      throw new Error("Could not find locale: ".concat(locale, " \n").concat(error.message));
    }
  }
}
exports.doImport = doImport;
function importLocale(locale) {
  var isBrowser = typeof document !== 'undefined';
  if (!locale && isBrowser) {
    locale = document.documentElement && document.documentElement.dataset && document.documentElement.dataset.language;
    throw new Error('Locale is not set');
  }
  // if in a browser environment, A fallback will not be done here, as the
  // expectation is that the laguage file is present on the page, and no other
  // language will be. So a fallback will always fail. Due to the synchronous
  // nature of the l10n module, we cannot easily async load a language file.
  // A page refresh will be required.
  return doImport(locale, isBrowser ? undefined : 'en_US');
}
exports.importLocale = importLocale;